/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../../components/UI'
import {FC, useEffect, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../../_metronic/helpers'
import {PermissionModel} from '../../../../../model'
import {getPermissionByOption} from '../../../../../services'
import {deletePermissionByOption} from '../../../../../services'
import {useCentral} from '../../../../../../../hooks/useCentral'
import {ModalAddPermission} from '../modal/ModalAddPermission'
import Swal from 'sweetalert2'

const TablePermission: FC = () => {
  const {data, setData, setPagination, loading, setLoading, clearSelected, selectedOn, pagination} =
    useKTable()
  const {currentTabItem, isAllowed} = useCentral()
  const [showModalNew, setShowModalNew] = useState(false)
  const [idPermission, setIdPermission] = useState<any>('')
  const [detailpermission, setDetailPermission] = useState<PermissionModel | any>(null)

  const handleClear = () => {
    setIdPermission('')
  }
  const getPermissionByOptionList = async () => {
    try {
      clearSelected()
      setLoading(true)
      const {data: response} = await getPermissionByOption(
        pagination.currentPage,
        currentTabItem.idToEdit,
      )
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleEdit = (item: PermissionModel) => {
    const filter = data.filter((detail) => detail.id === item.id)
    setDetailPermission(filter[0])
    setIdPermission(item.id)
    setShowModalNew(true)
  }
  useEffect(() => {
    getPermissionByOptionList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getPermissionByOptionList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  const columns: Column<PermissionModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => (
        <KTableSelectionCellNonMultiple
          id={props.data[props.row.index].id}
          disable={!props.data[props.row.index].flagActions}
        />
      ),
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Permiso' />,
      accessor: 'opcion',
    },

    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('PERMISO/EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEdit(props.data[props.row.index])}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const filter = data.filter((detail) => detail.id === selectedOn[0])
        setLoading(true)
        // const mappedSelected = selected.map((item) => ({Id: item}))

        let obj = {
          vistaPermisoId: currentTabItem.idToEdit,
          lstOpciones: [
            {
              opcion: filter[0]?.opcion,
              codigo: filter[0]?.codigo,
            },
          ],
        }
        const {data: response} = await deletePermissionByOption(obj)
        if (!response.error) {
          getPermissionByOptionList()
        } else {
        }
        getPermissionByOptionList()
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleNew = () => {
    setShowModalNew(true)
  }

  return (
    <>
      {isAllowed('PERMISO/LISTAR') && (
        <KTCard shadow className='m-5'>
          <div className='d-flex justify-content-end p-2 me-5'>
            {isAllowed('PERMISO/AGREGAR') && (
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
            )}
            {isAllowed('PERMISO/ELIMINAR') && (
              <button
                type='button'
                className='btn btn-primary me-3'
                disabled={selectedOn.length < 1}
                onClick={handleDelete}
              >
                Eliminar
              </button>
            )}
          </div>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
          <ModalAddPermission
            show={showModalNew}
            setShow={setShowModalNew}
            getPermissionByOptionList={getPermissionByOptionList}
            detailpermission={detailpermission}
            idPermission={idPermission}
            setIdPermissionList={handleClear}
          />
        </KTCard>
      )}
    </>
  )
}

const TablePermissionWrapper = () => {
  return (
    <KTableProvider>
      <TablePermission />
    </KTableProvider>
  )
}
export {TablePermissionWrapper}
